// usePreloadUserNotifications.js
import { useEffect, useRef } from 'react';

// Context
import { useUser } from 'context/UserContext';

import { subscribeToUserNotifications } from 'services/notifications/NotificationService';

/**
 * Custom hook to load notifications for a specific user.
 */
const usePreloadUserNotifications = () => {

  // User Context
  const { user, setUserNotifications } = useUser();

  // Track previous notifications to detect new ones
  const previousNotificationsRef = useRef([]);

  useEffect(() => {

    // Exit early if no selected user
    if (!user || !user.key) {
      setUserNotifications([]);
      previousNotificationsRef.current = [];
      return;
    }

    const load = () => {
      const handleUpdate = (notifications) => {
        // Sort notifications by dateCreated descending (newest first)
        const sortedNotifications = [...notifications].sort((a, b) => {
          const aDate = a.dateCreated?.toDate?.() ?? new Date(0);
          const bDate = b.dateCreated?.toDate?.() ?? new Date(0);
          return bDate - aDate;
        });

        // Check for new notifications and show toast
        const previousKeys = new Set(previousNotificationsRef.current.map(n => n.key));
        const newNotifications = sortedNotifications.filter(n => !previousKeys.has(n.key) && !n.isRead);

        newNotifications.forEach(notification => {
          if (notification.title) {
            /*
            toast.success(notification.title, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            */
          }
        });

        // Update previous notifications reference
        previousNotificationsRef.current = sortedNotifications;

        setUserNotifications(sortedNotifications);
      };

      return subscribeToUserNotifications(user.key, handleUpdate);
    };

    const unsubscribeNotifications = load();

    return () => {
      if (unsubscribeNotifications) {
        unsubscribeNotifications();
      }
    };
  }, [user, setUserNotifications]);

};

export default usePreloadUserNotifications;